module.exports = __webpack_public_path__ + "static/img/function-box-img2.9ebac9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img2.png
// module id = EJSv
// module chunks = 0